<ion-app>
  <app-updates-notification></app-updates-notification>
  <app-notification-alert></app-notification-alert>
  <ion-menu side="start" contentId="main-content" class="menu-new-design">
    <ion-content id="my-content" *ngIf="isLoggedIn">
      <ion-list class="ion-no-margin ion-no-padding">
        <ion-item lines="none">
          <img class="menu-logo" [src]="headerLogoPath" [alt]="headerLogoAltName" />
        </ion-item>

        <ion-item detail="true" class="cursor-pointer" (click)="presentProfileModal()" lines="none">
          <ion-label class="user-friendly-name">
            {{ userFriendlyName }}
          </ion-label>
        </ion-item>

        <ng-container *ngFor="let menuItem of menuList">
          <ion-item
            *ngIf="menuItem.name === 'Menu.SignOut'"
            class="main-items"
            lines="none"
            detail="false"
            (click)="logout()"
            routerLink="/account/login"
            routerLinkActive="linkActive"
          >
            <ion-icon [src]="menuItem.icon" slot="start"></ion-icon>
            <ion-label>
              {{ menuItem.name | translate }}
            </ion-label>
          </ion-item>

          <ion-item
            *ngIf="menuItem.name === 'Menu.Support'"
            class="main-items"
            lines="none"
            detail="false"
            href="https://support.switchdin.com/hc/en-us"
            target="_blank"
          >
            <ion-icon slot="start" name="help-circle"></ion-icon>
            <ion-label>
              {{ menuItem.name | translate }}
            </ion-label>
          </ion-item>

          <ion-item
            class="main-items"
            lines="none"
            detail="false"
            *ifHasPermission="menuItem.isListed && (menuItem.keyForPermission ?? true)"
            [routerLink]="menuItem.name === 'Admin.Installer' ? getInstallerRouterLink() : menuItem.routerLink"
            routerDirection="forward"
            routerLinkActive="linkActive"
          >
            <ion-icon [src]="menuItem.icon" slot="start"></ion-icon>
            <ion-label>
              {{ menuItem.name | translate }}
            </ion-label>
          </ion-item>
        </ng-container>
      </ion-list>
    </ion-content>

    <ion-row>
      <ion-col class="ion-text-center">
        <ion-text class="text-medium fs-15">v{{ version }}</ion-text>
        <app-powered-by-footer [showColoredLogo]="'true'"></app-powered-by-footer>
      </ion-col>
    </ion-row>
    <ion-footer class="ion-text-center ion-padding-vertical">
      <ion-row>
        <ion-col>
          <a [href]="privacyPolicy" target="_blank" rel="noopener noreferrer" class="text-deco-none text-medium">
            {{ 'Admin.PrivacyPolicy' | translate }}
          </a>
          <span>|</span>
          <a [href]="termsConditions" target="_blank" rel="noopener noreferrer" class="text-deco-none text-medium">
            {{ 'Admin.TermsAndConditions' | translate }}
          </a>
        </ion-col>
      </ion-row>
    </ion-footer>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
